import React from "react";
import AttendeeAvatar from "./AttendeeAvatar";
import { Attendee } from "../../app/types";

interface Props {
  attendee: Attendee;
}

const AttendeeRow = ({ attendee }: Props) => {
  const { name, company, title, avatarUrl } = attendee;
  return (
    <div className="row">
      <AttendeeAvatar url={avatarUrl} name={name} />
      <div className="info">
        <h1 className="name">{name}</h1>
        {title && <p>{title}</p>}
        {company && <p>{company}</p>}
      </div>
      <style jsx>{`
        p {
          font-size: 0.7rem;
          padding: 0;
          margin: 0;
        }
        .row {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 10px 0 10px 20px;
        }
        .info {
          padding: 0 0 0 10px;
        }
        .name {
          font-weight: bold;
          font-size: 0.9rem;
          color: #343434;
          padding: 0;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default AttendeeRow;
